const routes = [
    {
        path: '/chaperones',
        component: () => import('../pages/Index'),
        meta: {
            isAuthenticated: true,
            permission: 'chaperone_index'
        }
    }
];

export default routes;
